import axios from '../Api/api';

export default function profile() {
    return new Promise((resolve, reject) => {
        axios.get("profile/userInfo", {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('authToken')}`,
            },
        })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
